import { createStore, withProps } from "@ngneat/elf";
import { withEntities } from "@ngneat/elf-entities";
import { withRequestsStatus } from "@ngneat/elf-requests";

import { CategoriesFilter, Category } from "./categories.model";
import { PaginationDto } from "@utils/pagination.dto";

interface CategoryStoreProps {
  filters: CategoriesFilter;
  pagination?: PaginationDto;
}

export const categoriesStore = createStore(
  { name: "categories" },
  withProps<CategoryStoreProps>({
    filters: { page: 1, orderBy: "name" },
  }),
  withEntities<Category>(),
  withRequestsStatus()
);
